module.exports = __webpack_public_path__ + "static/img/gs3.d42664b6.jpg";